import { Apollo } from "apollo-angular";
import { Injectable } from "@angular/core";
import {
  billsByPlaceAndStateAndIds,
  userByUID,
  getAllCountries,
  usernameByToken,
  placesByUser,
  getSubmodulesByPlaceAndModuleAndRole,
  getPermissions,
  allCoins,
  getRolesByPlace,
  getCellars,
  getAllBlackBoxDetailType,
  getUsersByPlace,
  findUsersByPlace,
  getBlackBoxesByPlace,
  searchBlackBoxes,
  getInventories,
  getDetailsByInventory,
  findFeaturesByPlace,
  getMensuremets,
  detailByInventory,
  getProductStates,
  keysFeatures,
  getPriceHistory,
  featuresByDetail,
  getBillsByPlaceAndState,
  getBillDetailByBillAndPlace,
  getDeliveryByUser,
  getBillDetailsForDeliveryOrder,
  getProductsByPlaceAndCriteria,
  getFilesByPlaceAndType,
  shoppersByPlace,
  checkIfAccountIsEnough,
  getAllTaxes,
  getInventoriesByPlace,
  getBlackBoxByUserAndPlace,
  checkIfAccountsIsEnough,
  getActiveCellarsByPlace,
  getAllTariff,
  isPromotionalCodeValidForCashier,
  getBlackBoxByUser,
  checkIfPasswordAndAccountIsEnough,
  getBillsForDelivery,
  getBillDetailsForDelivery,
  sonTags,
  searchTagByCategory,
  searchTags,
  getAllBillStates,
  getBillsByStateAndPlaceAndDateRange,
  reportForProviders,
  getDeliveryStates,
  getAllBillDetailStates,
  getCompaniesByModule,
  getCompanyByUniqueName,
  getCategoriesOfProducts,
  allTagsCategory,
  tagsByCategory,
  getAllPromotionalCodes,
  generateRandomPromotionalCodeName,
  billsByIds,
  billsDeliveredReport,
  notAvailableAddressToSend,
  recentUsers,
  addressByPerson,
  discounts,
  downloadXML,
  downloadRespXML,
  electronicBillByBill,
  serverDate,
  productFeatureByCadesurCode,
  detailByInventorySearch,
  tagsByInventoryDetailPlace,
  activities,
  userByCriteria,
  billsByPlace,
  getBill,
  getAllCabys,
  productFeaturesNoCabys,
  dataByPlace,
  featuresByCellar,
  featuresByInventory,
  featuresByInventoryDetail,
  queryFeatures,
  getRandomByPlace,
  tagsByInventory,
  featureById,
  topFeatures,
  queryRecentUsers,
  devicesByUser,
  PlaceById,
  ninja,
  featuresNotInReport,
  getUserByCriteria,
  locationsByPlace,
  toDeliverByDate,
  billPendingStateAndId,
  billCurrentCart,
  activeUserByPlace,
  productAndCategory,
  getBillsToPrepare,
  getProductsByInventory,
  placeClients,
  findBillsByState,
  validatePhone,
  getStatsById,
  getAdminsByPlace,
  getPermissionsByUser,
  allPersonType,
  getCabysByCriteria,
  getProductByIdWithoutFeatures,
  getPermissionsSubmodules,
  getPlace,
  getByBillIdTypeFE,
  getAllReferenceCode,
  getAllActivities,
  getBillStateMarket,
  getBillsDateRange,
  getTopSellingProducts,
  getTotalBillDateRange,
  getTopBuyingUsers,
  validateProductFeature,
} from "./graphql/querys";
import {
  firebaseAuth,
  updatedUserState,
  sendRequest,
  resendBillEmailTo,
  suscribeToNotification,
  updateDefaultCoin,
  createCellar,
  createInventory,
  createBlackBox,
  updateBlackBox,
  sendNotification,
  createBlackBoxDetail,
  transactionBlackBoxDetail,
  updateBlackBoxDetail,
  hideBlackBox,
  restoreBlackBox,
  handleCellarState,
  removeInventory,
  createInventoryDetail,
  hideInventoryDetail,
  updateCellar,
  updateInventory,
  updateInventoryDetail,
  restoreInventoryDetail,
  createFeatureFile,
  addProductDetail,
  updateProductDetail,
  removeProductDetail,
  createFeature,
  updateFeaturePrice,
  updateFeatureQuantity,
  removeFeatureFile,
  addProductTag,
  removeProductTag,
  updateInventoryState,
  createProductFeatureCode,
  createDeliveryForPlaceAdmin,
  updateBillDetailState,
  checkBillDetail,
  updateDeliveryState,
  ordersReadyToCollect,
  updateBillDetailForShopperB,
  updateBillDetailsToDelivered,
  createPlaceFile,
  createBillForCashier,
  assignNewTaxToProduct,
  cloneInventoryDetail,
  moveInventoryDetailOfInventory,
  updateRestrictedProduct,
  payWithAccountFromCashier,
  payBillCashierMultiple,
  updateFeatureLocation,
  updatePreparationTimeOfProductFeature,
  cloneProductFeatureIntoProduct,
  deliveryUserPosition,
  updateNextPointOfDelivery,
  finishBillDelivery,
  updateBillDeliveryToReady,
  createDeliveryForShopperB,
  payWithAccountFromDelivery,
  updateBillAsNotDelivered,
  createDelivery,
  billToEB,
  removePlaceCode,
  subscribeSudo,
  updateCompanyPortraitPicture,
  updateCompanyProfilePicture,
  createCompanyPortraitPicture,
  updateCompanyProfileInfo,
  deleteCompanyPortraitPicture,
  updatePlacePicture,
  updatePlaceProfile,
  createPlaceProfileTag,
  updateOnlyPlaceProfileTagInfo,
  updateWholePlaceProfileTag,
  updateUniqueNameOfPlace,
  insertSchedule,
  removeSchedule,
  updateTag,
  addSonTag,
  createTag,
  updatePromotionalCode,
  updatePromotionalCodeState,
  createPromotionalCode,
  createProductKeyFeature,
  insertPlaceInfo,
  updatePlaceInfo,
  deletePlaceInfo,
  aproveNotAvailableAddressToSend,
  updateCadesurCodeProductFeature,
  createProductDiscount,
  setProductDiscount,
  removeProductDiscount,
  createCadesurFeature,
  syncCadesurFeature,
  syncCadesurBarcodes,
  subscribeToPlace,
  subscribeUsers,
  removeSonTag,
  removeProductFeatureTag,
  createProductFeatureTag,
  setPlaceDelivery,
  syncCadesurPrices,
  createBillCashier,
  updateBillDetailQuantityCashier,
  createBillDetailCashier,
  deleteBillDetailCashier,
  updateBillUser,
  resendEB,
  receptionEB,
  payCartCashier,
  syncCadesurCabys,
  setDiscountState,
  updateFeaturesQuantity,
  updateDeliveryMoment,
  SaveGalleryFile,
  deleteProductsAndFeature,
  createRefundsByBill,
  updateGalleryFileState,
  updateRefundState,
  moveProductFeatureIntoInventory,
  updateInventoryAll,
  saveFeature,
  updatePerson,
  updateUserProfilePicture,
  saveTag,
  removeTagProduct,
  savePermissions,
  registerUserAdminByPlace,
  cloneRole,
  editFeatureTag,
  createCreditNote,
  createCreditNoteMT,
  updatePlace,
  cancelBill,
  createBillOnly,
  removeSubTag,
  deletePlaceDelivery,
  setPlaceDeliveryCoordinates,
  editProductFeatureState,
} from "./graphql/mutations";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(private apollo: Apollo) {}

  ////////////////////////////////////////////
  ///////////////MUTATIONS///////////////////
  //////////////////////////////////////////

  SaveGalleryFile = (FilePath, FirebaseId, PlaceId) =>
    this.apollo.mutate<any>({
      mutation: SaveGalleryFile,
      variables: { FilePath, FirebaseId, PlaceId },
    });

  firebaseAuth = (user) =>
    this.apollo.mutate<any>({
      mutation: firebaseAuth,
      variables: { user },
    });

  updatedUserState = (user) =>
    this.apollo.mutate<any>({
      mutation: updatedUserState,

      variables: { user },
    });

  sendRequest = (message) =>
    this.apollo.mutate<any>({
      mutation: sendRequest,
      variables: { message },
    });

  updateDefaultCoin = (FK_Coin) =>
    this.apollo.mutate<any>({
      mutation: updateDefaultCoin,
      variables: { FK_Coin },
    });

  createCellar = (cellar) =>
    this.apollo.mutate<any>({
      mutation: createCellar,

      variables: { cellar },
    });

  createCreditNote = (docEB) =>
    this.apollo.use("EB").mutate<any>({
      mutation: createCreditNote,
      variables: { docEB },
    });

  createCreditNoteMT = (docEB) =>
    this.apollo.use("EB").mutate<any>({
      mutation: createCreditNoteMT,
      variables: { docEB },
    });

  createInventory = (inventory) =>
    this.apollo.mutate<any>({
      mutation: createInventory,

      variables: { inventory },
    });

  createBlackBox = (blackBox) =>
    this.apollo.mutate<any>({
      mutation: createBlackBox,
      variables: { blackBox },
    });

  updateBlackBox = (blackBox) =>
    this.apollo.mutate<any>({
      mutation: updateBlackBox,
      variables: { blackBox },
    });

  sendNotification = (notification) =>
    this.apollo.mutate<any>({
      mutation: sendNotification,
      variables: { notification },
    });

  createBlackBoxDetail = (blackBoxDetail) =>
    this.apollo.mutate<any>({
      mutation: createBlackBoxDetail,
      variables: { blackBoxDetail },
    });

  transactionBlackBoxDetail = (from, to, value) =>
    this.apollo.mutate<any>({
      mutation: transactionBlackBoxDetail,
      variables: { from, to, value },
    });

  updateBlackBoxDetailForAdmin = (blackBoxDetail) =>
    this.apollo.mutate<any>({
      mutation: updateBlackBoxDetail,
      variables: { blackBoxDetail },
    });

  hideBlackBox = (id) =>
    this.apollo.mutate<any>({
      mutation: hideBlackBox,
      variables: { id },
    });

  restoreBlackBox = (id) =>
    this.apollo.mutate<any>({
      mutation: restoreBlackBox,
      variables: { id },
    });

  handleCellarState = (id, state) =>
    this.apollo.mutate<any>({
      mutation: handleCellarState,
      variables: { id, state },
    });

  removeInventory = (id) =>
    this.apollo.mutate<any>({
      mutation: removeInventory,
      variables: { id },
    });

  createInventoryDetail = (detail) =>
    this.apollo.mutate<any>({
      mutation: createInventoryDetail,

      variables: { detail },
    });

  hideProduct = (id) =>
    this.apollo.mutate<any>({
      mutation: hideInventoryDetail,
      variables: { id },
    });

  updateCellar = (cellar) =>
    this.apollo.mutate<any>({
      mutation: updateCellar,

      variables: { cellar },
    });

  updateInventory = (inventory) =>
    this.apollo.mutate<any>({
      mutation: updateInventory,

      variables: { inventory },
    });

  updateInventoryDetail = (detail) =>
    this.apollo.mutate<any>({
      mutation: updateInventoryDetail,

      variables: { detail },
    });

  restoreInventoryDetail = (id) =>
    this.apollo.mutate<any>({
      mutation: restoreInventoryDetail,

      variables: { id },
    });

  createFeatureFile = (file) =>
    this.apollo.mutate<any>({
      mutation: createFeatureFile,

      variables: { file },
    });

  addProductDetail = (featureDetail) =>
    this.apollo.mutate<any>({
      mutation: addProductDetail,

      variables: { featureDetail },
    });

  updateProductDetail = (featureDetail) =>
    this.apollo.mutate<any>({
      mutation: updateProductDetail,

      variables: { featureDetail },
    });

  removeProductDetail = (id) =>
    this.apollo.mutate<any>({
      mutation: removeProductDetail,

      variables: { id },
    });
  updateInventoryAll = (inventory) =>
    this.apollo.mutate<any>({
      mutation: updateInventoryAll,

      variables: { inventory },
    });
  addFeature = (feature) =>
    this.apollo.mutate<any>({
      mutation: createFeature,

      variables: { feature },
    });

  updateFeaturePrice = (feature) =>
    this.apollo.mutate<any>({
      mutation: updateFeaturePrice,

      variables: { feature },
    });

  createProductDiscount = (discount) =>
    this.apollo.mutate<any>({
      mutation: createProductDiscount,

      variables: { discount },
    });

  updateFeatureQuantity = (feature) =>
    this.apollo.mutate<any>({
      mutation: updateFeatureQuantity,

      variables: { feature },
    });

  updateFeaturesQuantity = (features, quantity) =>
    this.apollo.mutate<any>({
      mutation: updateFeaturesQuantity,

      variables: { features, quantity },
    });

  removeFeatureFile = (id, FK_ProductFeature) =>
    this.apollo.mutate<any>({
      mutation: removeFeatureFile,

      variables: { id, FK_ProductFeature },
    });

  addProductTag = (productTag) =>
    this.apollo.mutate<any>({
      mutation: addProductTag,

      variables: { productTag },
    });

  removeProductTag = (FK_Product, FK_Tag) =>
    this.apollo.mutate<any>({
      mutation: removeProductTag,

      variables: { FK_Product, FK_Tag },
    });

  updateInventoryState = (id, State_Inventory) =>
    this.apollo.mutate<any>({
      mutation: updateInventoryState,
      variables: { id, State_Inventory },
    });

  createProductFeatureCode = (featureCode, FK_Place) =>
    this.apollo.mutate<any>({
      mutation: createProductFeatureCode,
      variables: { featureCode, FK_Place },
    });

  createDeliveryForPlaceAdmin = (bills, FK_Place, FK_User) =>
    this.apollo.mutate<any>({
      mutation: createDeliveryForPlaceAdmin,
      variables: { bills, FK_Place, FK_User },
    });

  updateBillDetailState = (id, state, quantity?) =>
    this.apollo.mutate<any>({
      mutation: updateBillDetailState,
      variables: {
        id,
        state,
        quantity,
      },
    });

  checkBillDetail = (id, quantity) =>
    this.apollo.mutate<any>({
      mutation: checkBillDetail,
      variables: { id, quantity },
    });

  updateDeliveryState = (delivery) =>
    this.apollo.mutate<any>({
      mutation: updateDeliveryState,
      variables: { delivery },
    });

  ordersReadyToCollect = (id: number, forceComplete: boolean) =>
    this.apollo.mutate<any>({
      mutation: ordersReadyToCollect,
      variables: { id, forceComplete },
    });

  updateBillDetailForShopperB = (details) =>
    this.apollo.mutate<any>({
      mutation: updateBillDetailForShopperB,
      variables: { details },
    });

  updateBillDetailsToDelivered = (details, FK_Place) =>
    this.apollo.mutate<any>({
      mutation: updateBillDetailsToDelivered,
      variables: { details, FK_Place },
    });

  createPlaceFile = (FK_Place, File) =>
    this.apollo.mutate<any>({
      mutation: createPlaceFile,
      variables: { FK_Place, File },
    });

  createBillForCashier = (bill, detail) =>
    this.apollo.mutate<any>({
      mutation: createBillForCashier,
      variables: { bill, detail },
    });

  assignNewTaxToProduct = (id, FK_Product) =>
    this.apollo.mutate<any>({
      mutation: assignNewTaxToProduct,
      variables: { id, FK_Product },
    });

  cloneInventoryDetail = (detail) =>
    this.apollo.mutate<any>({
      mutation: cloneInventoryDetail,
      variables: { detail },
    });

  moveInventoryDetailOfInventory = (FK_Inventory, FK_Product) =>
    this.apollo.mutate<any>({
      mutation: moveInventoryDetailOfInventory,
      variables: { FK_Inventory, FK_Product },
    });

  updateRestrictedProduct = (id, Restricted_Product) =>
    this.apollo.mutate<any>({
      mutation: updateRestrictedProduct,
      variables: { id, Restricted_Product },
    });

  payWithAccountFromCashier = (FK_Account, Total) =>
    this.apollo.mutate<any>({
      mutation: payWithAccountFromCashier,
      variables: { FK_Account, Total },
    });

  updateBlackBoxDetail = (blackBoxDetail, binnacle, FK_Bill) =>
    this.apollo.mutate<any>({
      mutation: updateBlackBoxDetail,
      variables: { blackBoxDetail, binnacle, FK_Bill },
    });

  payBillCashierMultiple = (Values, binnacle, FK_Bill) =>
    this.apollo.mutate<any>({
      mutation: payBillCashierMultiple,
      variables: { Values, binnacle, FK_Bill },
    });

  updateFeatureLocation = (id, Location_ProductFeature) =>
    this.apollo.mutate<any>({
      mutation: updateFeatureLocation,

      variables: { id, Location_ProductFeature },
    });

  moveProductFeatureIntoInventory = (id, FK_Product, newQuantity) =>
    this.apollo.mutate<any>({
      mutation: moveProductFeatureIntoInventory,

      variables: { id, FK_Product, newQuantity },
    });

  updatePreparationTimeOfProductFeature = (
    id,
    PreparationTime_ProductFeature
  ) =>
    this.apollo.mutate<any>({
      mutation: updatePreparationTimeOfProductFeature,

      variables: { id, PreparationTime_ProductFeature },
    });

  updateCadesurCodeProductFeature = (id, CadesurCode_ProductFeature) =>
    this.apollo.mutate<any>({
      mutation: updateCadesurCodeProductFeature,

      variables: { id, CadesurCode_ProductFeature },
    });

  cloneProductFeatureIntoProduct = (id, FK_Product, FK_Inventory) =>
    this.apollo.mutate<any>({
      mutation: cloneProductFeatureIntoProduct,

      variables: { id, FK_Product, FK_Inventory },
    });

  deliveryUserPosition = (position) =>
    this.apollo.mutate<any>({
      mutation: deliveryUserPosition,
      variables: { position },
    });

  updateNextPointOfDelivery = (delivery) =>
    this.apollo.mutate<any>({
      mutation: updateNextPointOfDelivery,
      variables: { delivery },
    });

  finishBillDelivery = (id) =>
    this.apollo.mutate<any>({
      mutation: finishBillDelivery,
      variables: { id },
    });

  updateBillDeliveryToReady = (billId, deliveryId, firebaseId) =>
    this.apollo.mutate<any>({
      mutation: updateBillDeliveryToReady,
      variables: { billId, deliveryId, firebaseId },
    });

  createDeliveryForShopperB = (details, FK_Address, bills) =>
    this.apollo.mutate<any>({
      mutation: createDeliveryForShopperB,
      variables: { details, FK_Address, bills },
    });

  payWithAccountFromDelivery = (FK_Account, Total) =>
    this.apollo.mutate<any>({
      mutation: payWithAccountFromDelivery,
      variables: { FK_Account, Total },
    });

  updateBillAsNotDelivered = (id, Description_NotDeliveredBill) =>
    this.apollo.mutate<any>({
      mutation: updateBillAsNotDelivered,
      variables: { id, Description_NotDeliveredBill },
    });

  createDelivery = (variables) =>
    this.apollo.mutate<any>({
      mutation: createDelivery,

      variables,
    });

  billToEB = (id) =>
    this.apollo.mutate<any>({
      mutation: billToEB,
      variables: { id },
    });

  removePlaceCode = (code, id) =>
    this.apollo.mutate<any>({
      mutation: removePlaceCode,
      variables: { code, id },
    });

  subscribeSudo = (token) =>
    this.apollo.mutate<any>({
      mutation: subscribeSudo,
      variables: { token },
    });

  subscribeUsers = (token) =>
    this.apollo.mutate<any>({
      mutation: subscribeUsers,
      variables: { token },
    });

  updateCompanyPortraitPicture = (id, Route_File, FirebaseId, idToDelete) =>
    this.apollo.mutate<any>({
      mutation: updateCompanyPortraitPicture,
      variables: { id, Route_File, FirebaseId, idToDelete },
    });

  updateCompanyProfilePicture = (id, Route_File, FirebaseId, fileToDelete) =>
    this.apollo.mutate<any>({
      mutation: updateCompanyProfilePicture,
      variables: { id, Route_File, FirebaseId, fileToDelete },
    });

  createCompanyPortraitPicture = (id, Route_File, FirebaseId) =>
    this.apollo.mutate<any>({
      mutation: createCompanyPortraitPicture,
      variables: { id, Route_File, FirebaseId },
    });

  updateCompanyProfileInfo = (company) =>
    this.apollo.mutate<any>({
      mutation: updateCompanyProfileInfo,
      variables: { company },
    });

  deleteCompanyPortraitPicture = (id) =>
    this.apollo.mutate<any>({
      mutation: deleteCompanyPortraitPicture,
      variables: { id },
    });

  updatePlacePicture = (id, Route_File, FirebaseId, type) =>
    this.apollo.mutate<any>({
      mutation: updatePlacePicture,
      variables: { id, Route_File, FirebaseId, type },
    });

  updatePlaceProfile = (place) =>
    this.apollo.mutate<any>({
      mutation: updatePlaceProfile,
      variables: { place },
    });

  createPlaceProfileTag = (newTag, Route_File, FirebaseId) =>
    this.apollo.mutate<any>({
      mutation: createPlaceProfileTag,
      variables: { newTag, Route_File, FirebaseId },
    });

  updateOnlyPlaceProfileTagInfo = (tag) =>
    this.apollo.mutate<any>({
      mutation: updateOnlyPlaceProfileTagInfo,
      variables: { tag },
    });

  updateWholePlaceProfileTag = (tag, Route_File, FirebaseId) =>
    this.apollo.mutate<any>({
      mutation: updateWholePlaceProfileTag,
      variables: { tag, Route_File, FirebaseId },
    });

  updateUniqueNameOfPlace = (id, UniqueName_Place) =>
    this.apollo.mutate<any>({
      mutation: updateUniqueNameOfPlace,
      variables: { id, UniqueName_Place },
    });

  insertSchedule = (schedules) =>
    this.apollo.mutate<any>({
      mutation: insertSchedule,

      variables: { schedules },
    });

  removeSchedule = (id) =>
    this.apollo.mutate<any>({
      mutation: removeSchedule,

      variables: { id },
    });

  updateTag = (tag) =>
    this.apollo.mutate<any>({
      mutation: updateTag,

      variables: { tag },
    });

  addSonTag = (tagTree) =>
    this.apollo.mutate<any>({
      mutation: addSonTag,

      variables: { tagTree },
    });

  removeSonTag = (tagTree) =>
    this.apollo.mutate<any>({
      mutation: removeSonTag,

      variables: { tagTree },
    });

  createTag = (tag) =>
    this.apollo.mutate<any>({
      mutation: createTag,

      variables: { tag },
    });

  updatePromotionalCode = (promotionalCode) =>
    this.apollo.mutate<any>({
      mutation: updatePromotionalCode,
      variables: { promotionalCode },
    });

  updatePromotionalCodeState = (id, FK_PromotionalCodeState) =>
    this.apollo.mutate<any>({
      mutation: updatePromotionalCodeState,
      variables: { id, FK_PromotionalCodeState },
    });

  createPromotionalCode = (promotionalCode) =>
    this.apollo.mutate<any>({
      mutation: createPromotionalCode,
      variables: { promotionalCode },
    });

  createProductKeyFeature = (feature) =>
    this.apollo.mutate<any>({
      mutation: createProductKeyFeature,
      variables: { feature },
    });

  insertPlaceInfo = (placeInfo) =>
    this.apollo.mutate<any>({
      mutation: insertPlaceInfo,
      variables: { placeInfo },
    });

  updatePlaceInfo = (placeInfo) =>
    this.apollo.mutate<any>({
      mutation: updatePlaceInfo,
      variables: { placeInfo },
    });

  deletePlaceInfo = (id) =>
    this.apollo.mutate<any>({
      mutation: deletePlaceInfo,
      variables: { id },
    });

  aproveNotAvailableAddressToSend = (id) =>
    this.apollo.mutate<any>({
      mutation: aproveNotAvailableAddressToSend,
      variables: { id },
    });

  setProductDiscount = (FK_ProductPrice, FK_ProductDiscount) =>
    this.apollo.mutate<any>({
      mutation: setProductDiscount,
      variables: { FK_ProductPrice, FK_ProductDiscount },
    });

  removeProductDiscount = (FK_ProductPrice, FK_ProductDiscount) =>
    this.apollo.mutate<any>({
      mutation: removeProductDiscount,
      variables: { FK_ProductPrice, FK_ProductDiscount },
    });

  createCadesurFeature = (feature) =>
    this.apollo.mutate<any>({
      mutation: createCadesurFeature,
      variables: { feature },
    });

  syncCadesurFeature = (feature) =>
    this.apollo.mutate<any>({
      mutation: syncCadesurFeature,
      variables: { feature },
    });

  syncCadesurBarcodes = (featureBarcodes) =>
    this.apollo.mutate<any>({
      mutation: syncCadesurBarcodes,
      variables: { featureBarcodes },
    });

  createProductFeatureTag = (FK_ProductFeature, FK_Tag) =>
    this.apollo.mutate<any>({
      mutation: createProductFeatureTag,
      variables: { FK_ProductFeature, FK_Tag },
    });

  removeProductFeatureTag = (FK_ProductFeature, FK_Tag) =>
    this.apollo.mutate<any>({
      mutation: removeProductFeatureTag,
      variables: { FK_ProductFeature, FK_Tag },
    });

  setPlaceDelivery = (placeDelivery) =>
    this.apollo.mutate<any>({
      mutation: setPlaceDelivery,
      variables: { placeDelivery },
    });

  setDeletePlaceDelivery = (id: number) =>
    this.apollo.mutate<any>({
      mutation: deletePlaceDelivery,
      variables: { id },
    });

  setCoordinates = (
    FK_Place: number,
    lat: number,
    lng: number,
    address: string
  ) =>
    this.apollo.mutate<any>({
      mutation: setPlaceDeliveryCoordinates,
      variables: { FK_Place, lat, lng, address },
    });

  syncCadesurPrices = (featurePrices) =>
    this.apollo.mutate<any>({
      mutation: syncCadesurPrices,
      variables: { featurePrices },
    });

  createBillCashier = (detail) =>
    this.apollo.mutate<any>({
      mutation: createBillCashier,
      variables: { detail },
    });

  createBillOnly = (id) =>
    this.apollo.mutate<any>({
      mutation: createBillOnly,
      variables: { id },
    });

  updateBillDetailQuantityCashier = (id, quantity, total) =>
    this.apollo.mutate<any>({
      mutation: updateBillDetailQuantityCashier,
      variables: { id, quantity, total },
    });

  createBillDetailCashier = (detail) =>
    this.apollo.mutate<any>({
      mutation: createBillDetailCashier,
      variables: { detail },
    });

  deleteBillDetailCashier = (id) =>
    this.apollo.mutate<any>({
      mutation: deleteBillDetailCashier,
      variables: { id },
    });

  deleteProductsAndFeature = (id) =>
    this.apollo.mutate<any>({
      mutation: deleteProductsAndFeature,
      variables: { id },
    });

  updateBillUser = (id, FK_User) =>
    this.apollo.mutate<any>({
      mutation: updateBillUser,
      variables: { id, FK_User },
    });

  payCartCashier = (cart) =>
    this.apollo.use("EB").mutate<any>({
      mutation: payCartCashier,
      variables: { cart },
    });

  syncCadesurCabys = (cabys) =>
    this.apollo.use("EB").mutate<any>({
      mutation: syncCadesurCabys,
      variables: { cabys },
    });

  setDiscountState = (id, State) =>
    this.apollo.mutate<any>({
      mutation: setDiscountState,
      variables: { id, State },
    });

  updateDeliveryMoment = (id, DeliveryMoment) =>
    this.apollo.mutate<any>({
      mutation: updateDeliveryMoment,
      variables: { id, DeliveryMoment },
    });

  createRefundsByBill = (refunds) =>
    this.apollo.mutate<any>({
      mutation: createRefundsByBill,

      variables: { refunds },
    });

  updateRefundState = (refund) =>
    this.apollo.mutate<any>({
      mutation: updateRefundState,

      variables: { refund },
    });

  updateGalleryFileState = (id) =>
    this.apollo.mutate<any>({
      mutation: updateGalleryFileState,

      variables: { id },
    });
  saveFeature = (feature) =>
    this.apollo.mutate<any>({
      mutation: saveFeature,

      variables: { feature },
    });

  editTag = (feature, tagId) =>
    this.apollo.mutate<any>({
      mutation: editFeatureTag,
      variables: { feature, tagId },
    });

  updateUserFullInformation(user) {
    return this.apollo.mutate<any>({
      mutation: updatePerson,

      variables: { user },
    });
  }

  updateUserProfilePicture = (Route_File, FirebaseId) =>
    this.apollo.mutate<any>({
      mutation: updateUserProfilePicture,
      variables: { Route_File, FirebaseId },
    });

  saveTag = (tag) =>
    this.apollo.mutate<any>({
      mutation: saveTag,
      variables: { tag },
    });
  removeTagProduct = (tagId) =>
    this.apollo.mutate<any>({
      mutation: removeTagProduct,
      variables: { tagId },
    });

  removeSubTag = (tagId) =>
    this.apollo.mutate<any>({
      mutation: removeSubTag,
      variables: { tagId },
    });

  savePermissions = (userId, submodules, placeId) =>
    this.apollo.mutate<any>({
      mutation: savePermissions,
      variables: { userId, submodules, placeId },
    });

  registerUserAdminByPlace = (user, placeId: number) =>
    this.apollo.mutate<any>({
      mutation: registerUserAdminByPlace,
      variables: { user, placeId },
    });
  cloneRole = (userId, userClone, placeId) =>
    this.apollo.mutate<any>({
      mutation: cloneRole,
      variables: { userId, userClone, placeId },
    });

  updatePlaceMT = (place) =>
    this.apollo.mutate<any>({
      mutation: updatePlace,
      variables: { place },
    });
  cancelBill = (billId, reason, file) =>
    this.apollo.mutate<any>({
      mutation: cancelBill,
      variables: { billId, reason, file },
    });

  updateFeatureState = (featureId, stateId) =>
    this.apollo.mutate<any>({
      mutation: editProductFeatureState,
      variables: { featureId, stateId },
    });

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////QUERIES/////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  validatePhone = (phone, codeRegion) =>
    this.apollo.query<any>({
      query: validatePhone,
      variables: {
        phone,
        codeRegion,
      },
    });

  activities = () =>
    this.apollo.use("Places").query<any>({
      query: activities,
    });

  userByUID = (uid) =>
    this.apollo.query<any>({
      query: userByUID,

      variables: { uid },
    });

  addressByPerson = (id) =>
    this.apollo.query<any>({
      query: addressByPerson,

      variables: { id },
    });

  getAllCountries = () =>
    this.apollo.query<any>({
      query: getAllCountries,
    });

  usernameByToken = (meToken) =>
    this.apollo.query<any>({
      query: usernameByToken,
      variables: { meToken },
    });

  placesByUser = (id) =>
    this.apollo.query<any>({
      query: placesByUser,

      variables: {
        user: id,
        module: 3,
      },
    });

  submodulesByPlaceAndModuleAndRole = (FK_Place, FK_Role) =>
    this.apollo.query<any>({
      query: getSubmodulesByPlaceAndModuleAndRole,

      variables: {
        FK_Role,
        FK_Place,
        FK_Module: 3,
      },
    });

  permissionsBySubmoduleAndRole = (submodule, role) =>
    this.apollo.query<any>({
      query: getPermissions,

      variables: {
        FK_Submodule: submodule,
        FK_Role: role,
      },
    });

  suscribeToNotification = (notificationDevice) =>
    this.apollo.mutate<any>({
      mutation: suscribeToNotification,
      variables: { notificationDevice },
    });

  subscribeToPlace = (tokenFcm, id) =>
    this.apollo.mutate<any>({
      mutation: subscribeToPlace,
      variables: { token: tokenFcm, id },
    });

  userByCriteria = (criteria) =>
    this.apollo.query<any>({
      query: getUserByCriteria,

      variables: {
        criteria,
      },
    });

  allCoins = () =>
    this.apollo.query<any>({
      query: allCoins,
    });

  billsByPlaceAndStateAndIds = (
    FK_Place,
    FK_BillState,
    FK_BillDetailState,
    BillDetailIds?
  ) =>
    this.apollo.query<any>({
      query: billsByPlaceAndStateAndIds,
      variables: { FK_Place, FK_BillState, FK_BillDetailState, BillDetailIds },
    });

  billPendingStateAndId = (FK_Place, FK_BillStateFilter, IdsBills?) =>
    this.apollo.query<any>({
      query: billPendingStateAndId,
      variables: { FK_Place, FK_BillStateFilter, IdsBills },
    });

  getUserByPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: activeUserByPlace,
      variables: { FK_Place },
    });

  getProductByCategory = (FK_Place) =>
    this.apollo.query<any>({
      query: productAndCategory,
      variables: { FK_Place },
    });

  billCurrentCart = (FK_Place) =>
    this.apollo.query<any>({
      query: billCurrentCart,
      variables: { FK_Place },
    });

  findBillsByState = (State_Id, FK_Place, page, size) =>
    this.apollo.query<any>({
      query: findBillsByState,
      variables: { FK_Place, State_Id, page, size },
    });

  getRolesByPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: getRolesByPlace,
      variables: { FK_Place },
    });

  getCellars = (id) =>
    this.apollo.query<any>({
      query: getCellars,

      variables: {
        id: id,
      },
    });

  getAllBlackBoxDetailType = () =>
    this.apollo.query<any>({
      query: getAllBlackBoxDetailType,
      variables: {},
    });

  getUsersByPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: getUsersByPlace,
      variables: { FK_Place },
    });

  findUsersByPlace = (Criteria, FK_Place) =>
    this.apollo.query<any>({
      query: findUsersByPlace,
      variables: { Criteria, FK_Place },
    });

  getBlackBoxesByPlace = (placeId) =>
    this.apollo.query<any>({
      query: getBlackBoxesByPlace,
      variables: { placeId },
    });

  searchBlackBoxes = (criteria, placeId) =>
    this.apollo.query<any>({
      query: searchBlackBoxes,
      variables: { criteria, placeId },
    });

  getInventories = (id, FK_Place) =>
    this.apollo.query<any>({
      query: getInventories,

      variables: { id, FK_Place },
    });

  findFeaturesByPlace = (criteria, id) =>
    this.apollo.query<any>({
      query: findFeaturesByPlace,

      variables: { criteria, id },
    });

  getMeasures = () =>
    this.apollo.query<any>({
      query: getMensuremets,
    });

  productsByInventory = (id, FK_Place) =>
    this.apollo.query<any>({
      query: detailByInventory,

      variables: { id, FK_Place },
    });

  getProductsByInventory = (id) =>
    this.apollo.query<any>({
      query: getProductsByInventory,
      variables: { getProductsByInventoryId: id },
    });

  getProductByIdWithoutFeatures = (id) =>
    this.apollo.query<any>({
      query: getProductByIdWithoutFeatures,

      variables: { getProductByIdWithoutFeatures: id },
    });
  detailByInventorySearch = (id, FK_Place) =>
    this.apollo.query<any>({
      query: detailByInventorySearch,

      variables: { id, FK_Place },
    });

  productStates = () =>
    this.apollo.query<any>({
      query: getProductStates,
    });

  getKeysFeatures = () =>
    this.apollo.query<any>({
      query: keysFeatures,
    });

  getPriceHistory = (id) =>
    this.apollo.query<any>({
      query: getPriceHistory,

      variables: { id },
    });

  featuresByDetail = (id, FK_Place) =>
    this.apollo.query<any>({
      query: featuresByDetail,

      variables: { id, FK_Place },
    });

  tagsByInventoryDetailPlace = (id, FK_Place) =>
    this.apollo.query<any>({
      query: tagsByInventoryDetailPlace,

      variables: { id, FK_Place },
    });

  getBillsByPlaceAndState = (FK_Place, FK_BillState, FK_BillDetailState) =>
    this.apollo.query<any>({
      query: getBillsByPlaceAndState,
      variables: { FK_Place, FK_BillState, FK_BillDetailState },
    });

  getBillsDateRange = (FK_Place, StartDate_Bill, EndDate_Bill) =>
    this.apollo.query<any>({
      query: getBillsDateRange,
      variables: { FK_Place, StartDate_Bill, EndDate_Bill },
    });
  getTopBuyingUsers = (FK_Place, StartDate_Bill, EndDate_Bill) =>
    this.apollo.query<any>({
      query: getTopBuyingUsers,
      variables: { FK_Place, StartDate_Bill, EndDate_Bill },
    });
  getTopSellingProducts = (StartDate_Bill, EndDate_Bill, FK_BillDetailState) =>
    this.apollo.query<any>({
      query: getTopSellingProducts,
      variables: { StartDate_Bill, EndDate_Bill, FK_BillDetailState },
    });
  getTotalBillDateRange = (FK_Place, StartDate_Bill, EndDate_Bill) =>
    this.apollo.query<any>({
      query: getTotalBillDateRange,
      variables: { FK_Place, StartDate_Bill, EndDate_Bill },
    });

  getBillDetailByBillAndPlace = (FK_Bill, FK_Place) =>
    this.apollo.query<any>({
      query: getBillDetailByBillAndPlace,
      variables: { FK_Bill, FK_Place },
    });

  recentUsers = (offset) =>
    this.apollo.query<any>({
      query: recentUsers,
      variables: { offset },
    });

  getPlaceClients = (
    token: string,
    placeID: number,
    limit: number,
    offset: number,
    criteria: string
  ) =>
    this.apollo.query<any>({
      query: placeClients,
      variables: {
        placeByClientParams: {
          placeID,
          pagination: {
            limit,
            offset,
          },
          criteria,
        },
      },
    });

  getDeliveryByUser = (FK_Place?) =>
    this.apollo.query<any>({
      query: getDeliveryByUser,

      variables: { FK_Place },
    });

  getBillDetailsForDeliveryOrder = (FK_Place?) =>
    this.apollo.query<any>({
      query: getBillDetailsForDeliveryOrder,

      variables: { FK_Place },
    });

  getProductsByPlaceAndCriteria = (criteria, FK_Place) =>
    this.apollo.query<any>({
      query: getProductsByPlaceAndCriteria,
      variables: { criteria, FK_Place },
    });

  getFilesByPlaceAndType = (FK_Place, FK_FileType) =>
    this.apollo.query<any>({
      query: getFilesByPlaceAndType,
      variables: { FK_Place, FK_FileType },
    });

  shoppersByPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: shoppersByPlace,
      variables: { FK_Place },
    });

  checkIfAccountIsEnough = (FK_Account, Total) =>
    this.apollo.query<any>({
      query: checkIfAccountIsEnough,
      variables: { FK_Account, Total },
    });

  getAllTaxes = () =>
    this.apollo.query<any>({
      query: getAllTaxes,
    });

  getInventoriesByPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: getInventoriesByPlace,
      variables: { FK_Place },
    });

  getBlackBoxByUserAndPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: getBlackBoxByUserAndPlace,
      variables: { FK_Place },
    });

  checkIfAccountsIsEnough = (toCheck) =>
    this.apollo.query<any>({
      query: checkIfAccountsIsEnough,
      variables: { toCheck },
    });

  getActiveCellarsByPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: getActiveCellarsByPlace,

      variables: { FK_Place },
    });

  getAllTariff = () =>
    this.apollo.query<any>({
      query: getAllTariff,
    });

  isPromotionalCodeValidForCashier = (FK_User, UniqueCode_PromotionalCode) =>
    this.apollo.query<any>({
      query: isPromotionalCodeValidForCashier,

      variables: { FK_User, UniqueCode_PromotionalCode },
    });

  getBlackBoxByUser = () =>
    this.apollo.query<any>({
      query: getBlackBoxByUser,
    });

  checkIfPasswordAndAccountIsEnough = (
    FK_User,
    FK_Account,
    Total,
    Password_User
  ) =>
    this.apollo.query<any>({
      query: checkIfPasswordAndAccountIsEnough,
      variables: { FK_User, FK_Account, Total, Password_User },
    });

  getBillsForDelivery = () =>
    this.apollo.query<any>({
      query: getBillsForDelivery,
    });

  getBillDetailsForDelivery = (FK_Place?) =>
    this.apollo.query<any>({
      query: getBillDetailsForDelivery,

      variables: { FK_Place },
    });

  sonTags = (id) =>
    this.apollo.query<any>({
      query: sonTags,

      variables: { id },
    });

  searchTagByCategory = (value, categoryId) =>
    this.apollo.query<any>({
      query: searchTagByCategory,
      variables: { value, categoryId },
    });
  getStatsById = (placeId) =>
    this.apollo.query<any>({
      query: getStatsById,
      variables: { placeId },
    });
  searchTags = (criteria) =>
    this.apollo.query<any>({
      query: searchTags,

      variables: { criteria },
    });
  getAllBillStates = () =>
    this.apollo.query<any>({
      query: getAllBillStates,
    });

  getBillStateMarket = () =>
    this.apollo.query<any>({
      query: getBillStateMarket,
    });

  getBillsByStateAndPlaceAndDateRange = (
    FK_Place,
    FK_BillState,
    StartDate_Bill,
    EndDate_Bill
  ) =>
    this.apollo.query<any>({
      query: getBillsByStateAndPlaceAndDateRange,
      variables: { FK_Place, FK_BillState, StartDate_Bill, EndDate_Bill },
    });

  reportForProviders = (FK_Place) =>
    this.apollo.query<any>({
      query: reportForProviders,

      variables: { FK_Place },
    });

  getDeliveryStates = () =>
    this.apollo.query<any>({
      query: getDeliveryStates,
    });

  getAllBillDetailStates = () =>
    this.apollo.query<any>({
      query: getAllBillDetailStates,
    });

  getCompaniesByModule = () =>
    this.apollo.query<any>({
      query: getCompaniesByModule,
      variables: { FK_Module: 3 },
    });

  getCompanyByUniqueName = (UniqueName_Company) =>
    this.apollo.query<any>({
      query: getCompanyByUniqueName,
      variables: { UniqueName_Company },
    });

  getCategoriesOfProducts = (criteria) =>
    this.apollo.query<any>({
      query: getCategoriesOfProducts,
      variables: { criteria },
    });

  allTagsCategory = () =>
    this.apollo.query<any>({
      query: allTagsCategory,
    });

  tagsByCategory = (id) =>
    this.apollo.query<any>({
      query: tagsByCategory,

      variables: { id },
    });

  getAllPromotionalCodes = () =>
    this.apollo.query<any>({
      query: getAllPromotionalCodes,
    });

  generateRandomPromotionalCodeName = () =>
    this.apollo.query<any>({
      query: generateRandomPromotionalCodeName,
    });

  billsByIds = (ids) =>
    this.apollo.query<any>({
      query: billsByIds,
      variables: { ids },
    });

  billsDeliveredReport = (dateA, dateB) =>
    this.apollo.query<any>({
      query: billsDeliveredReport,
      variables: { dateA, dateB },
    });

  notAvailableAddressToSend = () =>
    this.apollo.query<any>({
      query: notAvailableAddressToSend,
    });

  discounts = (FK_Place, State) =>
    this.apollo.query<any>({
      query: discounts,
      variables: { FK_Place, State },
    });

  downloadXML = (id) =>
    this.apollo.use("EB").query<any>({
      query: downloadXML,
      variables: { id },
    });

  downloadRespXML = (id) =>
    this.apollo.use("EB").query<any>({
      query: downloadRespXML,
      variables: { id },
    });

  electronicBillByBill = (id, FK_Place) =>
    this.apollo.use("EB").query<any>({
      query: electronicBillByBill,
      variables: { id, FK_Place },
    });

  serverDate = () =>
    this.apollo.query<any>({
      query: serverDate,
    });

  productFeatureByCadesurCode = (id) =>
    this.apollo.query<any>({
      query: productFeatureByCadesurCode,

      variables: { id },
    });

  resendBillEmailTo = (id, to, FK_Place) =>
    this.apollo.use("EB").mutate<any>({
      mutation: resendBillEmailTo,

      variables: { id, to, FK_Place },
    });

  queryUserByCriteria = (criteria) =>
    this.apollo.query<any>({
      query: userByCriteria,

      variables: { criteria },
    });

  billsByPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: billsByPlace,

      variables: { FK_Place },
    });

  getBill = (id) =>
    this.apollo.query<any>({
      query: getBill,

      variables: { id },
    });

  resendEB = (id) =>
    this.apollo.use("EB").query<any>({
      query: resendEB,

      variables: { id },
    });

  receptionEB = (id, FK_Place) =>
    this.apollo.use("EB").query<any>({
      query: receptionEB,
      variables: { id, FK_Place },
    });

  getAllCabys = () =>
    this.apollo.query<any>({
      query: getAllCabys,
    });

  getCabysByCriteria = (criteria: string) =>
    this.apollo.query<any>({
      query: getCabysByCriteria,
      variables: { criteria },
    });

  productFeaturesNoCabys = (FK_Place) =>
    this.apollo.query<any>({
      query: productFeaturesNoCabys,
      variables: { FK_Place },
    });

  placeData = (FK_Place) =>
    this.apollo.query<any>({
      query: dataByPlace,
      variables: { FK_Place },
    });

  featuresByCellar = (FK_Cellar, FK_Place, offset) =>
    this.apollo.query<any>({
      query: featuresByCellar,
      variables: { FK_Cellar, FK_Place, offset },
    });

  featuresByInventory = (FK_Inventory, FK_Place, offset) =>
    this.apollo.query<any>({
      query: featuresByInventory,
      variables: {
        FK_Inventory,
        FK_Place,
        query: { where: { FK_Inventory }, skip: offset },
      },
    });

  featuresByInventoryDetail = (FK_Inventory_Detail, FK_Place, offset) =>
    this.apollo.query<any>({
      query: featuresByInventoryDetail,
      variables: { FK_Inventory_Detail, FK_Place, offset },
    });

  queryFeatures = (Criteria, FK_Place, Offset) =>
    this.apollo.query<any>({
      query: queryFeatures,
      variables: { Criteria, FK_Place, Offset },
    });

  getRandomByPlace = (FK_Place, Offset) =>
    this.apollo.query<any>({
      query: getRandomByPlace,
      variables: { FK_Place, Offset },
    });

  tagsByInventory = (id) =>
    this.apollo.query<any>({
      query: tagsByInventory,

      variables: { id },
    });

  featureById = (id) =>
    this.apollo.query<any>({
      query: featureById,

      variables: { id },
    });

  topFeatures = (date, limit, states) =>
    this.apollo.query<any>({
      query: topFeatures,

      variables: { date, limit, states },
    });

  queryRecentUsers = (criteria, offset) =>
    this.apollo.query<any>({
      query: queryRecentUsers,

      variables: { criteria, offset },
    });

  devicesByUser = (FK_User) =>
    this.apollo.query<any>({
      query: devicesByUser,

      variables: { FK_User },
    });

  place = (id) =>
    this.apollo.use("Places").query<any>({
      query: PlaceById,

      variables: { id },
    });

  ninja = (uid) =>
    this.apollo.use("EB").query<any>({
      query: ninja,
      variables: { uid },
    });

  featuresNotInReport = (features, FK_Place) =>
    this.apollo.query<any>({
      query: featuresNotInReport,
      variables: { features, FK_Place },
    });

  locationsByPlace = (FK_Place) =>
    this.apollo.query<any>({
      query: locationsByPlace,
      variables: { FK_Place },
    });

  toDeliverByDate = (dateA, dateB, FK_Place) =>
    this.apollo.query<any>({
      query: toDeliverByDate,
      variables: { dateA, dateB, FK_Place },
    });
  getDetailsByInventory = (billId, stateId) =>
    this.apollo.query<any>({
      query: getDetailsByInventory,
      variables: { billId, stateId },
    });

  getBillsToPrepare = (fkPlace) =>
    this.apollo.query<any>({
      query: getBillsToPrepare,
      variables: { fkPlace },
    });

  getAdminsByPlace = (placeId) =>
    this.apollo.query<any>({
      query: getAdminsByPlace,
      variables: { placeId },
    });
  getPermissionsByUser = (placeId: number, userId: number) =>
    this.apollo.query<any>({
      query: getPermissionsByUser,
      variables: { placeId, userId },
    });

  allPersonTypes = () =>
    this.apollo.query<any>({
      query: allPersonType,
    });

  getPermissionsSubmodules = (roleId: number) => {
    return this.apollo.query<any>({
      query: getPermissionsSubmodules,
      variables: { roleId },
    });
  };
  getBillingProfilePlace = (id: string | number) =>
    this.apollo.use("EB").query<any>({
      query: getPlace,
      variables: { where: { id: Number(id) } },
    });

  getByBillIdTypeFE = (FK_Bill: string, type: number) =>
    this.apollo.use("EB").query<any>({
      query: getByBillIdTypeFE,
      variables: { FK_Bill, type },
    });

  getAllReferenceCode = () =>
    this.apollo.use("EB").query<any>({
      query: getAllReferenceCode,
      variables: {},
    });

  getAllActivities = () =>
    this.apollo.query<any>({
      query: getAllActivities,
    });
  validateProductFeature = (id: string, quantity: number) => {
    return this.apollo.query<any>({
      query: validateProductFeature,
      variables: { id, quantity },
    });
  };
}
